export default __webpack_public_path__ + "static/media/shadow-bright-spring.42ed7342.png";